import { Badge } from '@/components/ui/badge';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { cn } from 'src/lib/utils';

import { useApplications, useApplicationTabCounts, type ApplicationTab } from '../model';

const ApplicationTabs = () => {
  const { tab, setTab } = useApplications();
  const counts = useApplicationTabCounts();

  return (
    <Tabs value={tab} onValueChange={(value) => setTab(value as ApplicationTab)}>
      <TabsList className="h-auto flex-wrap justify-start gap-1 border border-border bg-background-soft lg:h-10 lg:flex-nowrap lg:justify-center">
        <TabsTrigger value="all" className="h-8 font-semibold text-slate-700 hover:bg-black/4">
          All{' '}
          <Badge variant="secondary" className="px-1.25 py-0 text-2xs h-4.5 min-w-4.5 rounded-full">
            {counts.all}
          </Badge>
        </TabsTrigger>
        <TabsTrigger
          value="unread_tasks"
          className={cn(
            'h-8 font-semibold text-slate-700 gap-1.5 hover:bg-black/4',
            Boolean(counts.unread_tasks) && 'text-destructive data-[state=active]:text-destructive',
          )}
        >
          {Boolean(counts.unread_tasks) && <span className="size-1.5 rounded-full bg-destructive" />}
          Unread tasks{' '}
          <Badge
            variant={counts.unread_tasks ? 'destructive' : 'secondary'}
            className="px-1.25 py-0 text-2xs h-4.5 min-w-4.5 rounded-full"
          >
            {counts.unread_tasks}
          </Badge>
        </TabsTrigger>
        <TabsTrigger value="unclaimed" className="h-8 font-semibold text-slate-700 hover:bg-black/4">
          Untitled{' '}
          <Badge variant="secondary" className="px-1.25 py-0 text-2xs h-4.5 min-w-4.5 rounded-full">
            {counts.unclaimed}
          </Badge>
        </TabsTrigger>
        <TabsTrigger value="your_applications" className="h-8 font-semibold text-slate-700 hover:bg-black/4">
          Your applications{' '}
          <Badge variant="secondary" className="px-1.25 py-0 text-2xs h-4.5 min-w-4.5 rounded-full">
            {counts.your_applications}
          </Badge>
        </TabsTrigger>
        <TabsTrigger value="vendor_applications" className="h-8 font-semibold text-slate-700 hover:bg-black/4">
          Vendor applications{' '}
          <Badge variant="secondary" className="px-1.25 py-0 text-2xs h-4.5 min-w-4.5 rounded-full">
            {counts.vendor_applications}
          </Badge>
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
};

export default ApplicationTabs;
